define('home/views/ForumSuggestionView',[
    'home/views/BaseSuggestionView',
    'home/templates/forumSuggestion',
], function (
    BaseSuggestionView,
    forumSuggestionTemplate
) {
    'use strict';

    /**
     * A view showing a single forum's avatar, name, and follow button.
     */
    var ForumSuggestionView = BaseSuggestionView.extend({
        template: forumSuggestionTemplate,
        className: 'recommended__item',

        templateHelpers: function () {
            return {
                hasFavicon: this.model.hasFavicon(),
            };
        },

        toggleFollow: function (evt) {
            this.constructor.__super__.toggleFollow.call(this, evt, 'follow forum');
        },
    });

    return ForumSuggestionView;
});

